<template>
  <div class="flex h-full py-4 pt-20 border gap-x-4">
    <help :info="info" />
    <div
      class="content-start w-64 max-h-full gap-2 overflow-auto transition-all duration-300 "
    >
      <div
        class="overflow-hidden rounded-r-lg shadow-md animate-animated animate-slideInLeft"
        v-if="step == 1"
      >
        <div class="p-1 text-xl font-bold text-secondary-content bg-secondary">
          Résultats ambigüe
        </div>
        <div class="p-2 bg-white">
          <div v-if="!ambigue.length" class="text-sm text-center text-gray-600">
            Aucun résultat ambigüe pour le moment
          </div>
          <template class="" v-for="r of ambigue" :key="r.resultID">
            <Card
              v-if="r.result"
              @click="filterByImpact(r.id)"
              @dragover.stop
              :result="r"
              :draggable="true"
            />
          </template>
        </div>
      </div>

      <div
        class="mt-6 overflow-hidden rounded-r-lg shadow-md animate-animated animate-slideInLeft"
        v-if="step >= 2"
      >
        <div class="p-1 text-lg font-bold text-secondary-content bg-secondary">
          Visualisation Heirachique
        </div>

        <div class="flex flex-col p-2 bg-white gap-y-2">
          <div
            :class="{
              '!bg-neutral/60 !text-neutral-content': !visibleParent.length
            }"
            @click="resetFilterImpact"
            class="p-1 text-sm text-center border border-l-4 border-r-4 rounded-l-lg rounded-r-lg cursor-pointer animate-animated animate-fadeInLeft text-neutral border-neutral hover:bg-neutral/60 hover:text-neutral-content"
          >
            Tout afficher
          </div>
          <template class="" v-for="r of fullImpact" :key="r.resultID">
            <div
              @click="filterByImpact(r.id)"
              :class="{
                '!bg-rouge/60 !text-primary-content': visibleParent.includes(
                  r.id
                )
              }"
              class="p-1 text-sm text-center border border-l-4 border-r-4 rounded-l-lg rounded-r-lg cursor-pointer animate-animated animate-fadeInLeft text-rouge border-rouge hover:bg-rouge/60 hover:text-primary-content"
            >
              {{ r.result.name }}
            </div>
          </template>
        </div>
      </div>
    </div>
    <div @resize="redraw" class="flex flex-col flex-1 h-full gap-y-4">
      <div class="flex items-center justify-end h-12 gap-x-2">
        <div class="flex-1 text-lg font-bold">
          Etape {{ step }} :
          {{
            step == 1
              ? "Glisser et déposer les résulat dans leur differentes catégories"
              : step == 2
              ? "Selectionnez les résultats et definissez des liens entres eux"
              : "Visualisation globale des relations"
          }}
        </div>
      </div>
      <div
        ref="diagram"
        class="relative flex flex-col h-[calc(100%-3rem)] gap-y-4"
        :class="{
          'border-4 border-secondary rounded-box': step >= 2
        }"
      >
        <div
          class="absolute bg-red-500"
          :style="{ top: -offsetTop + 'px', left: -offsetLeft + 'px' }"
          v-if="step >= 2"
        >
          <div
            class="absolute z-10 p-0 m-0 hover:bg-black"
            :class="{
              'bg-rouge ': item.map(x => x.result.computedType).includes(1),
              'bg-vert ':
                item.map(x => x.result.computedType).includes(2) &&
                !item.map(x => x.result.computedType).includes(1)
            }"
            style="line-height: 1px"
            :style="connect(item[0].id, item[1].id)"
            v-for="(item, index) in computedLiaisons"
            :key="index + computedLiaisons.length + resizeKey + step"
          ></div>
        </div>
        <Board
          :key="resizeKey"
          class=" h-1/3"
          :id="1"
          :step="step"
          :results="impact"
          :selected="selected"
          @selected="addToSelected"
          @report="updateResultPosition"
          @settype="setType"
        />
        <Board
          :key="resizeKey"
          class=" h-1/3"
          :id="2"
          :step="step"
          :results="effet"
          :selected="selected"
          @selected="addToSelected"
          @report="updateResultPosition"
          @settype="setType"
        />
        <Board
          :key="resizeKey"
          class=" h-1/3"
          :id="3"
          :step="step"
          :results="produit"
          :selected="selected"
          @selected="addToSelected"
          @report="updateResultPosition"
          @settype="setType"
        />
      </div>
    </div>
    <div
      class="flex flex-col content-start w-64 max-h-full gap-4 overflow-auto transition-all duration-300 "
    >
      <div class="flex items-center justify-end mt-4 gap-x-2">
        <div
          class="text-sm text-gray-500 animate-headShake animate-animated"
          @click="saveTypes"
          v-if="updatedTypes"
        >
          {{ saving ? "Enrégistrement ..." : "Modifications non enrégistréés" }}
        </div>

        <div
          class="transition-all btn btn-primary btn-sm animate-swing animate-animated"
          :class="{ ' btn-secondary': saving }"
          @click="step--"
          v-show="step != 1"
        >
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M3.97 12C3.97 16.41 7.59 20.03 12 20.03C16.41 20.03 20.03 16.41 20.03 12C20.03 7.59 16.41 3.97 12 3.97C7.59 3.97 3.97 7.59 3.97 12M2 12C2 6.46 6.46 2 12 2C17.54 2 22 6.46 22 12C22 17.54 17.54 22 12 22C6.46 22 2 17.54 2 12M10.46 11V8L6.5 12L10.46 16V13H17.5V11"
            />
          </svg>
        </div>

        <div
          class="transition-all btn btn-secondary btn-sm animate-swing animate-animated"
          :class="{ ' btn-disabled': saving }"
          @click="step++"
          v-show="step != 3"
        >
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="M20.03 12C20.03 7.59 16.41 3.97 12 3.97C7.59 3.97 3.97 7.59 3.97 12C3.97 16.41 7.59 20.03 12 20.03C16.41 20.03 20.03 16.41 20.03 12M22 12C22 17.54 17.54 22 12 22C6.46 22 2 17.54 2 12C2 6.46 6.46 2 12 2C17.54 2 22 6.46 22 12M13.54 13V16L17.5 12L13.54 8V11H6.5V13"
            />
          </svg>
        </div>
      </div>
      <div
        class="overflow-hidden rounded-l-lg shadow-md animate-animated animate-slideInRight"
      >
        <div class="p-1 text-xl font-bold text-secondary-content bg-secondary">
          Legende
        </div>
        <div class="flex flex-col p-2 bg-white gap-y-2" ref="legend">
          <h2 class="font-bold">Type de résultat</h2>
          <div class="flex items-center gap-x-4">
            <div
              class="flex items-center justify-center h-6 text-xs font-bold border border-l-4 border-r-4 rounded-l-lg rounded-r-lg w-14 border-rouge"
            >
              ...
            </div>
            <span>Impact</span>
          </div>

          <div class="flex items-center gap-x-4">
            <div
              class="flex items-center justify-center h-6 text-xs font-bold border border-l-4 border-r-4 rounded-l-lg rounded-r-lg w-14 border-vert"
            >
              ...
            </div>
            <span>Effet</span>
          </div>

          <div class="flex items-center gap-x-4">
            <div
              class="flex items-center justify-center h-6 text-xs font-bold border border-l-4 border-r-4 rounded-l-lg rounded-r-lg w-14 border-bleu"
            >
              ...
            </div>
            <span>Produit</span>
          </div>

          <h2 class="mt-4 font-bold">Niveau du résultat</h2>
          <div class="flex items-center gap-x-4" v-for="i of 3" :key="i">
            <div
              class="flex items-center justify-center w-5 h-5 text-xs font-bold border rounded-full border-primary"
            >
              {{ i }}
            </div>
            <span>Niveau {{ i }}</span>
          </div>
        </div>

        <div
          @click="_makeReport"
          class="p-2 font-bold text-center cursor-pointer bg-primary text-primary-content hover:bg-primary-focus"
        >
          Editer le rapport
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalMixins from "@/utils/mixins/mixin.js";
import Help from "@/components/Help.vue";
import Board from "@/components/MR/Board.vue";
import Card from "@/components/MR/Card.vue";
import * as htmlToImage from "html-to-image";
export default {
  mixins: [globalMixins],
  components: { Board, Card, Help },

  data() {
    return {
      editionActive: false,
      resizeKey: 0,
      resizeTimeout: null,
      newElt: {
        id: "",
        value: "",
        description: "",
        indicator: "",
        relatedCoords: {
          currentX: 0,
          currentY: 0
        }
      },
      editedElt: {
        id: "",
        value: "",
        description: "",
        indicator: "",
        relatedCoords: {
          currentX: 0,
          currentY: 0
        }
      },
      offsetTop: 0,
      offsetLeft: 0,
      liaisons: [],
      filterLiasons: [],
      visibleParent: [],
      resultats: [],
      selected: [],
      boardPositions: [],

      step: 1,
      updatedTypes: false,
      hasFinalResults: false,
      hasRelations: false,
      saving: false
    };
  },

  async mounted() {
    window.addEventListener("resize", this.redraw);
    this.resultats = JSON.parse(localStorage.getItem("temp-data"));
    if (this.currentFile === null) this.datas = [];
    else {
      const beforeResponse = await this.$axios.get(
        "MRResultClassificationFinalsQueries/GetResultClassificationFinalsByFileID/" +
          this.currentFile.id
      );

      if (beforeResponse.data.length) {
        this.datas = beforeResponse.data.map(x => ({
          ...x,
          id: x.resultID,
          result: this.resultats.find(y => y.resultID == x.resultID),
          ...this.resultats.find(y => y.resultID == x.resultID),
          computedType: x.typeResult,
          computedTypeRatio: 1,

          type: {
            id: x.typeResult,
            value:
              x.typeResult == 1
                ? "Impact"
                : x.typeResult == 2
                ? "Effet"
                : x.typeResult == 3
                ? "Produit"
                : "Ambigüe"
          },
          level: {
            id: x.levelOfResult,
            value:
              x.levelOfResult == 1
                ? "Niveau 1"
                : x.levelOfResult == 2
                ? "Niveau 2"
                : x.levelOfResult == 3
                ? "Niveau 3"
                : "Niveau 1*"
          }
        }));
        this.hasFinalResults = true;

        return;
      }
      const response = await this.$axios.get(
        "/MRResultClassificationsQueries/GetResultClassificationAnalysisByFileID/" +
          this.currentFile.id
      );

      this.datas = this.doAnalyses(response.data);
      this.liaisons = [];
    }
  },

  computed: {
    info() {
      return {
        name: this.currentModule?.name,
        description: this.currentModule?.moduleDescription
      };
    },
    impact() {
      return this.datas.filter(
        x =>
          x.computedType === 1 &&
          (this.visibleParent.length ? this.visibleParent.includes(x.id) : true)
      );
    },

    fullImpact() {
      return this.datas.filter(x => x.computedType == 1);
    },

    effet() {
      return this.datas.filter(
        x =>
          x.computedType === 2 &&
          (this.visibleParent.length ? this.visibleParent.includes(x.id) : true)
      );
    },

    produit() {
      return this.datas.filter(
        x =>
          x.computedType === 3 &&
          (this.visibleParent.length ? this.visibleParent.includes(x.id) : true)
      );
    },

    ambigue() {
      return this.datas.filter(x => x.computedType === -1);
    },

    resultsPosition() {
      return window._.flatten(this.boardPositions.map(x => x.positions));
    },
    computedLiaisons() {
      return this.filterLiasons.length ? this.filterLiasons : this.liaisons;
    }
  },

  updated() {},

  watch: {
    step(val, prev) {
      if (prev != val) {
        this.selected = [];
        this.redraw();
      }

      if (val == 2) {
        this.getParticipantRelation();
      }
      if (val == 3) {
        this.getRelationBi();
      }
    }
  },

  methods: {
    async downloadImage() {
      var dataUrl = await htmlToImage.toPng(this.$refs.diagram);

      var dataUrl2 = await htmlToImage.toPng(this.$refs.legend);

      var link = document.createElement("a");
      link.download = "result-diagram.jpeg";
      link.href = dataUrl;
      var el = this.$refs.legend;
      var rect = el.getBoundingClientRect();
      return {
        data: dataUrl,
        legend: dataUrl2,
        isRectangle: true,
        width: (rect.width || el.offsetWidth) * 0.2645833333,
        height: (rect.height || el.offsetHeight) * 0.2645833333,
        title: "Analyse Relationnel des acteurs"
      };
    },
    async _makeReport() {
      this.generating = true;
      this.$swal.fire("Edition du rapport");
      this.$swal.showLoading();

      var pdfData = {
        module: this.currentModule,
        folder: this.currentFolder,
        file: this.currentFile,
        actors: window._.sortBy(this.datas, "name"),
        actorLabel: "Résultat",
        actorKey: "name",
        identificationLabel: ["Résultat", "Indication"],
        identificationKey: ["name", "indication"],
        titles: [
          "Identification de tous les résultats attendus possibles",
          "Classification/ catégorisation des résultats selon l’influence",
          "Visualisation de la matrice du modèle de résultats"
        ],
        categoriesLabel: ["Résultat", "Catégorie", "Niveau"],
        categoriesKey: ["type", "level"],
        images: [
          /* { data: "", legend: "", title: "" } */
        ]
      };
      var im1 = await this.downloadImage();

      pdfData.images.push(im1);
      console.log(pdfData);
      this.$swal.hideLoading();

      this.$toast.fire({ title: "Le rapport a été edité", icon: "success" });
      this.makeReport(pdfData);
    },
    resetFilterImpact() {
      this.visibleParent = [];
      this.filterLiasons = [];
    },
    filterByImpact(impactID) {
      var visibleParent = [impactID];
      var parents = [impactID];
      var liasons = [];
      while (parents.length) {
        var _temp = this.liaisons.filter(
          x =>
            (parents.includes(x[0].id) && x[0].isParent) ||
            (parents.includes(x[1].id) && x[1].isParent)
        );
        console.log("Liaisons by");
        console.log(_temp);
        liasons = [...liasons, ..._temp];
        parents = _temp.map(x => x.find(y => !y.isParent).id);
        console.log("New parents");
        console.log(parents);
        visibleParent = [...visibleParent, ...parents];
      }

      this.visibleParent = visibleParent;
      this.filterLiasons = liasons;
    },

    async getParticipantRelation() {
      this.saving = true;
      this.liaisons = [];
      const response = await this.$axios.get(
        "/MRResultRelationsQueries/GetResultRelationByParticipantID/" +
          this.myParticipant.participantID
      );

      console.log("Relation by partcipant");
      const relations = response.data.filter(
        x => x.fileID == this.currentFile.id
      );
      console.log();
      //this.liaisons.push(this.selected);
      //this.doAnalyses(beforeResponse.data);

      this.liaisons = relations.map(x => [
        {
          id: x.parentID,
          isParent: true,
          result: this.datas.find(y => y.resultID == x.parentID),
          resultRelationID: x.resultRelationID
        },
        {
          id: x.childID,
          isParent: false,
          result: this.datas.find(y => y.resultID == x.childID),
          resultRelationID: x.resultRelationID
        }
      ]);
      this.saving = false;
    },
    async getRelationBi() {
      this.saving = true;
      this.liaisons = [];
      var response = await this.$axios.get(
        "/MRResultRelationsQueries/GetResultRelationAnalysisByFile_V2/" +
          this.currentFile.id
      );
      this.liaisons = response.data.map(x => [
        {
          id: x.parentID,
          isParent: true,
          result: this.datas.find(y => y.resultID == x.parentID),
          resultRelationID: x.resultRelationID
        },
        {
          id: x.childID,
          isParent: false,
          result: this.datas.find(y => y.resultID == x.childID),
          resultRelationID: x.resultRelationID
        }
      ]);
      this.saving = false;
      return;
    },
    async saveRelation(relation, selected) {
      this.saving = true;

      var response = await this.$axios.post(
        "/MRResultRelationsCommands/PostResultRelation",
        relation
      );
      selected[0].resultRelationID = response.data.resultRelationID;
      selected[1].resultRelationID = response.data.resultRelationID;
      this.saving = false;
    },

    async deleteRelation(relationID) {
      this.saving = true;

      await this.$axios.delete(
        "/MRResultRelationsCommands/DeleteResultRelation/" + relationID
      );
      this.saving = false;
    },

    async saveTypes() {
      this.saving = true;
      if (this.hasFinalResults) {
        await this.$axios.delete(
          "/MRResultClassificationFinalsCommands/DeleteResultClassificationFinalByFileID/" +
            this.currentFile.id
        );
      }

      await this.$axios.post(
        "/MRResultClassificationFinalsCommands/PostResultClassificationFinalList",
        this.datas.map(x => ({
          ...x,
          typeResult: x.computedType
          //  levelOfResult: 0
        }))
      );
      this.saving = false;
      this.updatedTypes = false;
    },
    updateResultPosition(position) {
      var index = this.boardPositions.findIndex(x => x.id == position.id);
      if (index == -1) {
        this.boardPositions.push(position);
      } else {
        this.boardPositions[index] = position;
        this.boardPositions = [...this.boardPositions];
      }
      console.log("Position");
      //alert("Board Position updated");
      console.log(position);
    },
    connect(id1, id2) {
      console.log("connect");
      console.log(id1);
      console.log(id2);
      const i1 = this.resultsPosition.find(x => x.resultID == id1);
      const i2 = this.resultsPosition.find(x => x.resultID == id2);

      if (!i1 || !i2) return {};
      const off1 = this.getOffset(i1.position);

      const off2 = this.getOffset(i2.position);
      //console.log("Position 1 : " + i1.result.name, off1);
      //console.log("Position 2 : " + i1.result.name, off2);
      const thickness = 3;
      let x1 = off1.left + off1.width / 2;
      let y1 = off1.top + off1.height / 2;

      let x2 = off2.left + off2.width / 2;
      let y2 = off2.top + off2.height / 2;

      if (y1 > y2) {
        x1 += off2.width / 4;
      } else {
        x2 += off2.width / 4;
      }

      const length = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));

      const cx = (x1 + x2) / 2 - length / 2;
      const cy = (y1 + y2) / 2 - thickness / 2;

      const angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);

      const cssLine =
        "height:" +
        thickness +
        "px; left:" +
        cx +
        "px; top:" +
        cy +
        "px; width:" +
        length +
        "px; -moz-transform:rotate(" +
        angle +
        "deg); -webkit-transform:rotate(" +
        angle +
        "deg); -o-transform:rotate(" +
        angle +
        "deg); -ms-transform:rotate(" +
        angle +
        "deg); transform:rotate(" +
        angle +
        "deg);";

      return cssLine;
    },

    redraw() {
      // If there's a timer, cancel it

      this.offsetTop = this.$refs.diagram.offsetTop;
      this.offsetLeft = this.$refs.diagram.offsetLeft;
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
      }

      this.resizeTimeout = setTimeout(() => {
        this.resizeKey = Date.now();
      }, 400);
    },
    async addToSelected(element, selectedID, result) {
      if (this.selected.map(x => x.id).includes(selectedID)) {
        this.selected = this.selected.filter(x => x.id != selectedID);
      } else {
        if (this.selected.length > 1) return;

        var existingRelation = this.liaisons.find(
          x =>
            x.map(y => y.id).includes(this.selected[0]?.id) &&
            x.map(y => y.id).includes(selectedID)
        );

        console.log("Existing Relation");
        console.log(existingRelation);
        if (existingRelation) {
          var shouldDelete = await this.$swal.fire({
            title: "Cette relation existe",
            text: "Voulez vous la supprimer ?",
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Non, annuler",
            showCancelButton: true,
            showConfirmButton: true
          });
          if (shouldDelete.isConfirmed) {
            await this.deleteRelation(existingRelation[0].resultRelationID);
            this.liaisons = this.liaisons.filter(x => x != existingRelation);
          }
          this.selected = [];
          return;
        }
        if (this.selected[0]?.result?.computedType == result.computedType) {
          this.$swal.fire(
            "Impossible de faire la liason des résultat de même type"
          );
          this.selected = [];
          return;
        }

        this.selected = [
          ...this.selected,
          {
            element,
            id: selectedID,
            // rect: this.getOffset(element),
            result
          }
        ];
      }

      if (this.selected.length > 1) {
        var parent;
        var child;

        if (this.selected[0]?.result?.computedType < result.computedType) {
          parent = this.selected[0].result.resultID;
          this.selected[0].isParent = true;
          this.selected[1].isParent = false;
          child = this.selected[1].result.resultID;
        } else {
          parent = this.selected[1].result.resultID;
          this.selected[1].isParent = true;
          this.selected[0].isParent = false;
          child = this.selected[0].result.resultID;
        }
        console.log(this.selected);
        this.liaisons.push(this.selected);
        await this.saveRelation(
          {
            parentID: parent,
            childID: child,
            personID: this.myParticipant.participantID,
            fileID: this.currentFile.id
          },
          this.selected
        );
        this.selected = [];
      }
    },

    getOffset(el) {
      const rect = el.getBoundingClientRect();
      return {
        left: rect.left + window.pageXOffset,
        top: rect.top + window.pageYOffset,
        width: rect.width || el.offsetWidth,
        height: rect.height || el.offsetHeight
      };
    },

    setType(resultID, typeResult, levelOfResult) {
      this.datas.find(x => x.resultID == resultID).computedType = typeResult;
      this.datas.find(
        x => x.resultID == resultID
      ).levelOfResult = levelOfResult;
      clearTimeout(this.updatedTypes);
      this.updatedTypes = setTimeout(() => {
        this.saveTypes();
      }, 3000);
      //this.updatedTypes = true;
    },

    /// doAnalyses: Cette methode compte et regroupe les categorisatio des resultat ambigue ou pas
    doAnalyses(_data) {
      //var _ = window._;
      var result = _data.map(category => {
        let counter = {};
        category.typeResults.forEach(id =>
          counter[id] ? counter[id]++ : (counter[id] = 1)
        );
        console.log(counter);
        let max = Math.max(...Object.values(counter));

        // Getting array of highest duplicate values
        let highest = Object.entries(counter).filter(
          ([id, reps]) => id && reps === max
        );

        console.log(highest);

        return {
          ...category,
          result: this.resultats.find(x => x.resultID == category.resultID),
          id: category.resultID,
          levelOfResult: 1,
          computedType: highest.length > 1 ? -1 : parseInt(highest[0][0]),
          computedTypeRatio:
            highest.length > 1
              ? -1
              : counter[parseInt(highest[0][0])] /
                Object.values(counter).reduce((a, b) => a + b)
        };
      });

      console.log(result);
      return result;
    }
  }
};
</script>
